// Chapter 7 writing frames ("מסגרות"), uploaded 1.11.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch7_fN"> in src/chapters/chapter-7.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH7_FRAMES: Frame[] = [
  {
    "id": "ch7_f1",
    "n": "7.1",
    "title": "הפער שלי",
    "type": "lines",
    "intro": "עובדות בלבד, בלי שיפוט. אין תשובה נכונה.",
    "fields": [
      "השם שנתתי לו:",
      "הערך שאני מאמינה בו (מילה אחת):",
      "מה עשיתי בפועל (מה שמצלמה הייתה רואה):",
      "מה הגוף עשה אחר כך (לב / בטן / שינה), ובאיזו עוצמה (1-10):"
    ]
  },
  {
    "id": "ch7_f2",
    "n": "7.2",
    "title": "ההרגשה שהגוף רדף אחריה",
    "type": "choice5",
    "intro": "סמני אחת, ואז שורה אחת:",
    "fields": [
      "הקלה מיידית · תגמול קטן · קרבה · בריחה מכאב",
      "מה זה נתן לי באותה שנייה, ומה זה עלה לי אחר כך:"
    ]
  },
  {
    "id": "ch7_f3",
    "n": "7.3",
    "title": "החבילה שלי",
    "type": "lines",
    "intro": "",
    "fields": [
      "הפער שלי כעובדה (בלי \"הייתי צריכה\"):",
      "המשפט של \"זה מה שיש\" על עצמי, במילים שלי:",
      "מה אני רוצה לשנות, מתוך אהבה ולא מתוך כעס:"
    ]
  },
  {
    "id": "ch7_f4",
    "n": "7.4",
    "title": "שש השאלות",
    "type": "existing",
    "intro": "שורה אחת מתחת לשש השאלות שענית עליהן:",
    "fields": [
      "הערוץ שבו הפער שלי התחיל (שכלי / פיזי / רגשי / רוחני), ומה הוא עשה שם:"
    ]
  },
  {
    "id": "ch7_f5",
    "n": "7.5",
    "title": "טבלת הערוצים",
    "type": "existing",
    "intro": "שורה אחת מתחת לטבלה שמילאת:",
    "fields": [
      "המרכיב שהכי מנהל את הפער שלי, לחזק או לשחרר, ומי יעזור לי:"
    ]
  },
  {
    "id": "ch7_f6",
    "n": "7.6",
    "title": "שתי מערכות הפעלה, רגע אחד",
    "type": "lines",
    "intro": "",
    "fields": [
      "ההרגל שלי שהפער חשף, ומה אני משנה בו (משפט אחד):"
    ]
  },
  {
    "id": "ch7_f7",
    "n": "7.7",
    "title": "סכנה, או פרשנות",
    "type": "lines",
    "intro": "",
    "fields": [
      "מה מערכת ההישרדות שלי זיהתה כאיום:",
      "סכנת חיים? (כן / לא) ומה באמת היה שם:",
      "הערך שנדרס, ולטובת מה:"
    ]
  },
  {
    "id": "ch7_f8",
    "n": "7.8",
    "title": "המחיר, והמודעות",
    "type": "scale2",
    "intro": "1 = זה כבר מאחוריי, 10 = זה עדיין יושב בי כל יום.",
    "fields": [
      "מה מהרשימה הרגשתי בימים שאחרי (שינה / מצב רוח / מיקוד / מוטיבציה / אכילה / ריחוק):",
      "כמה זה עוד יושב בי",
      "מה אני יודעת היום על הפער שלא ידעתי ברגע עצמו:"
    ]
  },
  {
    "id": "ch7_f9",
    "n": "7.9",
    "title": "שני מיקומים על הסרגל של הערך",
    "type": "twocol_named",
    "intro": "1-10 על הסרגל של הערך שלי: 1 = הקצה הרחוק מהערך, 10 = הערך במלואו.",
    "fields": [
      "הסרגל של הערך שלי, שני הקצוות במילים שלי:",
      "איפה אני בדרך כלל (1-10)|איפה הייתי ברגע הפער (1-10)",
      "הפער בין השניים, והרגש שיצא ממנו:"
    ]
  },
  {
    "id": "ch7_f10",
    "n": "7.10",
    "title": "המחיר שלי, והמשפט הכן",
    "type": "lines",
    "intro": "",
    "fields": [
      "מה הפער עלה לי (גוף / שינה / קשר), ולמשך כמה זמן:",
      "מי כפה על מי, ומה (את עליו / הוא עלייך / את על עצמך):",
      "המשפט הכן, לאדם הנכון:"
    ]
  },
  {
    "id": "ch7_f11",
    "n": "7.11",
    "title": "הפער שלי, מתוך בחירה",
    "type": "final",
    "intro": "",
    "fields": [
      "הערך של הפער שלי נפל בקבוצה: מאמינה וחיה / מאמינה ולא חיה / לא מאמינה וחיה:",
      "הפער שלי, פעם שנייה (שלוש שורות, מתוך בחירה):",
      "",
      "",
      "הצעד הראשון בתוכנית שלי, והתאריך:",
      "המשפט שלי לפעם הבאה שמערכת ההישרדות תרצה לפקד:"
    ]
  }
];
